import { IStateTag } from '../../actions/filterTags';
import { Undergrounds } from '../../components/Undergrounds';

export const getTagIcon = (tag: IStateTag) => {
  if (tag.pointColor || tag.undergroundDetails) {
    return <Undergrounds pointColor={tag.pointColor} undergrounds={tag.undergroundDetails} />;
  }

  return null;
};
